import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDeleteServiceOps, IServiceOperation } from '../../../models/index';
import { ServiceOperationsState, UpdateServiceOperationsPayload } from '../../actions/types/services/ServiceOperationTypes';

/**
 * Initial Service Operations in store
 */
const initialState: ServiceOperationsState = {
  serviceOperations: [],
  statusMsg: '',
  importStatus: false
};

const serviceoperatinsSlice = createSlice({
  name: 'serviceOperations',
  initialState,
  reducers: {
    addServiceOperations: (
      state,
      actions: PayloadAction<IServiceOperation>
    ) => {
      state.serviceOperations.push(actions.payload);
    },
    addAllServiceOperations: (
      state,
      actions: PayloadAction<IServiceOperation[]>
    ) => {
      state.serviceOperations = actions.payload;
    },
    deleteServiceOperations: (state, actions: PayloadAction<IDeleteServiceOps>) => {
      state.serviceOperations.splice(actions.payload.indexNumber, 1);
      state.statusMsg = actions.payload.statusMsg;
    },
    updateServiceOperations: (state, actions: PayloadAction<UpdateServiceOperationsPayload>) => {
      state.serviceOperations.splice(actions.payload.index, 1, actions.payload.serviceOperation);
      state.statusMsg = actions.payload.statusMsg;
    },
    clearServiceOperations: (state) => {
      state.serviceOperations = initialState.serviceOperations;
    },
    statusMsgClearMaping: (state) => {
      state.statusMsg = '';
    },
    updateSOImportStatus: (state, action) => {
      state.importStatus = action.payload;
    }
  }
});
export const {
  addServiceOperations,
  addAllServiceOperations,
  clearServiceOperations,
  deleteServiceOperations,
  updateServiceOperations,
  statusMsgClearMaping,
  updateSOImportStatus
} = serviceoperatinsSlice.actions;
export default serviceoperatinsSlice.reducer;
